/* eslint-disable @typescript-eslint/no-explicit-any */
import tranquilo from "../../../../assets/img/tranquilo.png";
import unico from "../../../../assets/img/unico.png";
import familiar from "../../../../assets/img/familia.png";
import elegante from "../../../../assets/img/elegante.png";
import central from "../../../../assets/img/central.png";
import espacioso from "../../../../assets/img/espacioso.png";

const Descripciones = ({ setForm, form }: any) => {
  const aspectos = [
    {
      name: "Tranquilo",
      icon: tranquilo,
    },
    {
      name: "Único",
      icon: unico,
    },
    {
      name: "Familiar",
      icon: familiar,
    },
    {
      name: "Elegante",
      icon: elegante,
    },
    {
      name: "Central",
      icon: central,
    },
    {
      name: "Espacioso",
      icon: espacioso,
    },
  ];

  const onChange = (e: any) => {
    switch (e.target.name) {
      case "description":
      case "title":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "aspecto":
        {
          // let input = form;
          let aspectos = form.DESCRIPTION_PROPERTY;
          const aspecto = {
            id: "",
            //--'Tranquilo', 'Único', 'Familiar', 'Elegante', 'Central', 'Espacioso'--
            name: value,
            porperty_id: "",
            excursion_id: "",
            created_at: "",
          };

          if (
            form.DESCRIPTION_PROPERTY.filter(
              (i: { name: string }) => i.name == value
            ).length > 0
          ) {
            aspectos = form.DESCRIPTION_PROPERTY.filter(
              (i: { name: string }) => i.name != value
            );
          } else {
            aspectos.push(aspecto);
          }

          setForm({
            ...form,
            DESCRIPTION_PROPERTY: aspectos,
          });
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="grid lg:grid-cols-1 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          A continuación, describamos tu casa
        </span>
        <span>
          Elegí hasta 2 aspectos destacados. Los vamos a usar para comenzar tu
          descripción
        </span>
        <div className="grid grid-cols-2 gap-5 mb-5">
          {aspectos.map((t) => {
            if (
              form.DESCRIPTION_PROPERTY.filter(
                (i: { name: string }) => i.name == t.name
              ).length > 0
            ) {
              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="aspecto"
                    onClick={(event) => onClick(event, t.name)}
                  ></button>
                </label>
              );
            }

            return (
              <label
                className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                style={{ borderRadius: "20px" }}
              >
                <span className="flex items-center">
                  <img src={t.icon} width={20} className="me-2" alt="" />
                  {t.name}
                </span>
                <button
                  className="hidden"
                  name="aspecto"
                  onClick={(event) => onClick(event, t.name)}
                ></button>
              </label>
            );
          })}
        </div>
        <span className="font-bold text-black mb-2 block">
          Ahora, ponele título a tu casa
        </span>
        <span>
          Los títulos cortos funcionan mejor. No te preocupes, podés modificarlo
          más adelante.
        </span>
        <input
          className="py-3 w-full border rounded-xl"
          type="text"
          value={form.title}
          name="title"
          onChange={(event) => onChange(event)}
        />
        <span className="block font-bold mb-4">{form.title.length}/32</span>

        <span className="font-bold text-black mb-2 block">
          Describete como anfitrión
        </span>
        <span>
          Cuentanos quien eres y que hace de tu espacio un lugar especial.
        </span>
        <input
          className="py-3 w-full border rounded-xl"
          type="text"
          value={form.description}
          name="description"
          onChange={(event) => onChange(event)}
        />
        <span className="block font-bold">{form.description.length}/32</span>
      </div>
      <div></div>
    </div>
  );
};

export default Descripciones;
